// The sign-in pages' card (RFC-043 "Pages", byj-1wv.51.7): /login, a
// device's approval at /device, an invitation at /i/{token} and joining a
// class at /c/join are a card of their own rather than the page skeleton —
// one short form or one step, as wide as a form wants, with the side gutter a
// phone needs. Each is built from this card rather than writing its own: its
// title and what stands beside it, the lead under it, its body, and the way
// back once there is nothing left to do here.
import type { ReactNode } from "react";
import { t } from "../i18n";
import { Link } from "./Nav";
import { Mark } from "./Shell";

export function CardPage({ title, aside, lead, back, brand = false, className, testid, children }: {
  /** the card's heading; none where the body draws its own (a class's join view) */
  title?: ReactNode;
  /**
   * what stands at the title's line's end: the language on /login. Not the
   * card's actions, as PageHead's are: what a card does is its body's form.
   */
  aside?: ReactNode;
  /** what the card is for, under the title */
  lead?: ReactNode;
  /** the way back, once there is nothing left to do here */
  back?: { to: string; label: string };
  /** the product's mark and name over the title, where no shell names it (/login) */
  brand?: boolean;
  className?: string;
  testid?: string;
  children?: ReactNode;
}) {
  return (
    <main className={`card card-page stack${className ? ` ${className}` : ""}`} data-testid={testid}>
      {brand && (
        <div className="card-brand" data-testid="card-brand">
          <Mark />
          <span>{t("common:appName")}</span>
        </div>
      )}
      {(title || aside) && (
        <div className="card-page-head">
          {title && <h1>{title}</h1>}
          {aside}
        </div>
      )}
      {lead && <p className="muted flush">{lead}</p>}
      {children}
      {back && (
        <Link to={back.to} className="card-page-back">
          {back.label}
        </Link>
      )}
    </main>
  );
}
